import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { SetModalVisible } from "../../actions";
import withStyles from '../../decorators/withStyles';
import { gaEvent } from '../../utils/utils';
import Modal from '../Modal';
import ZillowCountryMap from '../ZillowCountryMap/ZillowCountryMap';
import styles from './HousingPage.css';


class HousingPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      embedOpen: false,
    };
  }

  openEmbed = (e) => {
    this.closeEmbed();
    gaEvent('modal', 'open', 'housing-embed');
    this.props.dispatch(SetModalVisible(true));
    this.setState({embedOpen: true});
  };

  closeEmbed = (e) => {
    this.props.dispatch(SetModalVisible(false));
    this.setState({embedOpen: false});
  };

  render() {
    // const metaImage = this.getMeta('og:image');
    // metaImage.content = '';

    // this.embedScript();

    const smEmbedCode = `<iframe width="600" height="700" scrolling="no" style="overflow:hidden;" src="https://riskfinder.climatecentral.org/housing" frameborder="0" allowfullscreen></iframe>`;
    const lgEmbedCode = `<iframe width="800" height="950" scrolling="no" style="overflow:hidden;" src="https://riskfinder.climatecentral.org/housing" frameborder="0" allowfullscreen></iframe>`;

    const embedButton = (
      <button id="embed-btn" onClick={this.openEmbed} title="Embed this map">
        <span className="embed-label">Embed</span>
        <span className="icon embed white"></span>
      </button>
    );

    const embedModal = (
      <Modal isOpen={this.state.embedOpen && this.props.modalVisible} handleClick={this.closeEmbed}
             title="Embed this map">
        <div className="content">
          <h3>Choose an appropriate size, then copy and paste the code for your website:</h3>
          <div className="indent">
            <h4>Medium (600x700)</h4>
            <textarea cols="100" rows="3" id="copypastethis">
            {smEmbedCode}
            </textarea>
          </div>
          <div className="indent">
            <h4>Large (800x950)</h4>
            <textarea cols="100" rows="3" id="copypastethis">
            {lgEmbedCode}
            </textarea>
          </div>
        </div>
      </Modal>
    );

    return (
      <div className="HousingPage">
        <div className="map-container">
          <h1>Housing Growth Rate Ratio for Risk Zone vs. Safer Areas</h1>
          <h3>Click on a state to explore.</h3>
          <ZillowCountryMap/>
        </div>
        <div className="embed-container">
          {embedButton}
          {embedModal}
        </div>
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  connect((state) => state),
)(HousingPage);
